<template>
  <div v-frag>
    <a
      v-if="showSwagPromo"
      href="https://appsumo.com/sumoday/giveaway?ref=giveawaynav"
      target="_blank"
      class="campaign-button swag"
    >
      <img
        :src="Hype"
        alt="promo"
        height="16"
        width="16"
      >
      <strong>Win custom swag</strong>
    </a>
    <a
      v-else-if="showAskSumo"
      href="/asksumo/?ref=asksumo-nav-bar"
      class="asksumo-button"
    >
      <img
        :src="CommentDots"
        alt="AskSumo"
        height="14"
        width="16"
        loading="lazy"
      >
      <strong>AskSumo</strong>
      <span v-if="!isSumoDayCampaign">&nbsp;and get 10% off</span>
    </a>
    <div v-else v-frag>
      <a
        v-if="isCampaign && !isEnded"
        :href="link"
        class="campaign-button"
      >
        <img
          :src="image"
          :alt="label"
          height="16"
          width="16"
        >
        <strong>{{ label }}</strong>
        <span v-if="!isEnded && hasTimer">{{ timeRemaining }}</span>
      </a>
      <!-- Shop Exclusives -->
      <a
        v-if="
          !isCampaign &&
            $store.state.session.user &&
            $store.state.session.user.has_plus
        "
        href="/collections/plus-exclusives/?ref=PEnav"
        class="campaign-button plus"
      >
        <img
          :src="ShopExclusivesIcon"
          alt="Shop Plus exclusives banner"
          height="24"
          width="24"
          loading="lazy"
        >
        <strong>Shop Plus exclusives</strong>
      </a>
      <!-- Shop Exclusives -->
      <!-- Join Plus -->
      <a
        v-if="
          !isCampaign &&
            $store.state.session.user &&
            !$store.state.session.user.has_plus
        "
        href="/plus/?ref=Plusnav"
        class="campaign-button plus"
      >
        <img
          :src="AppsumoPlusIcon"
          :alt="`AppSumo Plus ${plusPercentageOff}% banner`"
          height="12"
          width="126"
          loading="lazy"
        >
        <strong>Save {{ plusPercentageOff }}%</strong>
      </a>
      <!-- Join Plus -->
      <!-- Free Ideas Badge -->
      <a
        v-if="!isCampaign && !$store.state.session.user"
        href="/content/75-free-business-ideas?ref=nav"
        class="campaign-button free-ideas"
      >
        <img
          :src="EmailLoveIcon"
          alt="Get Free biz ideas banner"
          height="24"
          width="24"
          loading="lazy"
        >
        <strong>Get FREE biz ideas</strong>
      </a>
      <!-- Free Ideas Badge -->
    </div>
  </div>
</template>
<script>
import frag from 'vue-frag';
import CampaignsMixin from '~/mixins/campaigns';
import {
  CAMPAIGN_BUTTON_TIMER,
  ASKUMO_CLEANUP_EXPERIMENT_NAME,
  SWAG_PROMO_EXPERIMENT_NAME,
  SWAG_PROMO_CAMPAIGN_NAME,
} from '~/constants/global';
import TimerIcon from '~/static/timer.svg';
import ShopExclusivesIcon from '~/static/shop-exclusives.svg';
import EmailLoveIcon from '~/static/email-love.svg';
import AppsumoPlusIcon from '~/static/as-plus.svg';
import CommentDots from '~/static/comment-dots.svg';
import Hype from '~/static/hype.svg';

export default {
  directives: { frag },
  mixins: [CampaignsMixin],
  props: {
    isSumoDayCampaign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TimerIcon,
      ShopExclusivesIcon,
      EmailLoveIcon,
      AppsumoPlusIcon,
      CommentDots,
      Hype,
      currentDate: new Date(), // conflicts with 'now' from CampaignsMixin
      askSumo: 'disabled',
      askSumoReturning: 'disabled',
    };
  },
  async fetch() {
    this.askSumoReturning = await this.$experiments.enroll('asksumo-returning');

    if (!this.$store.state?.session?.user && this.swagCampaignActive) {
      await this.$store.dispatch('experiments/enrollByName', SWAG_PROMO_EXPERIMENT_NAME);
    }
  },
  computed: {
    swagCampaignActive() {
      return this.isCampaignActive(SWAG_PROMO_CAMPAIGN_NAME);
    },
    showSwagPromo() {
      return !this.$store.state.session.user
        && this.swagCampaignActive
        && this.$store.getters['experiments/getExperimentVariant'](
          SWAG_PROMO_EXPERIMENT_NAME,
        ) === 'enabled';
    },
    plusPercentageOff() {
      return this?.$store?.state?.session?.session?.plus_percentage_off ?? 10;
    },
    showAskSumo() {
      return !(this.$store.state.session.user) && this.$store.getters['experiments/getExperimentVariant'](
        ASKUMO_CLEANUP_EXPERIMENT_NAME,
      ) !== 'enabled';
    },
    image() {
      return this.campaign?.image || TimerIcon;
    },
    label() {
      return this.campaign?.label;
    },
    link() {
      return `${this.campaign?.link}?ref=nav_countdown`;
    },
    campaign() {
      return this.$store.getters.button;
    },
    timeRemaining() {
      let seconds = Math.floor((this.endDate - this.currentDate) / 1000);

      if (seconds > 0) {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor(seconds / 60) % 60;
        seconds %= 60;

        const parts = [];
        if (hours) {
          parts.push(String(hours).padStart(2, '0'));
        }

        parts.push(String(mins).padStart(2, '0'));

        if (hours || mins || seconds) {
          parts.push(String(seconds).padStart(2, '0'));
        }

        return parts.join(':');
      }

      return '00:00';
    },
    hasTimer() {
      if (this.isCampaign && !this.isEnded) {
        const now = new Date();
        const untilStart = this.endDate - now;

        return untilStart > -1 && untilStart < CAMPAIGN_BUTTON_TIMER;
      }

      return false;
    },
    isEnded() {
      const now = new Date();
      return now > this.endDate;
    },
    isCampaign() {
      return this.campaign && !this.isEnded;
    },
    endDate() {
      return this.campaign?.end_date ? new Date(this.campaign.end_date) : null;
    },
  },
  mounted() {
    this.startCampaignTimer();
  },
  beforeUnmount() {
    if (this.processId) {
      window.clearInterval(this.processId);
    }
  },
  methods: {
    startCampaignTimer() {
      this.processId = !this.processId
        && this.isCampaign
        && !this.isEnded
        && typeof window !== 'undefined'
        && window.setInterval(this.updateCampaignTimer, 1000);
    },
    updateCampaignTimer() {
      this.currentDate = new Date();

      // campaign has ended so stop timer
      if (this.isEnded) {
        window.clearInterval(this.processId);
        this.processId = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/dorado/themes/dorado';

.asksumo-button {
  font-size: 16px;
  display: flex;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 20px;
  padding-right: 20px;
  background-image: linear-gradient(90deg, #bcf2cb, #aedbf4);
  color: $black-pearl;

  img {
    margin-right: 5px;
    vertical-align: middle;
  }
}

.campaign-button {
  background-color: rgba(255, 87, 50, 0.15);
  color: #1b1b1b;
  display: flex;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 24px;
  padding: 4px 20px;
  border-radius: 40px;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(255, 87, 50, 0.3);
  }

  &.free-ideas {
    background-color: rgba(14, 110, 244, 0.15);

    &:hover {
      background-color: rgba(14, 110, 244, 0.3);
    }
  }

  &.swag {
    background-color: rgba(94, 244, 107, 0.15);

    &:hover {
      background-color: rgba(94, 244, 107, 0.3);
    }
  }

  strong {
    display: inline-block;
    flex-shrink: 0;
    font-weight: 500;
  }

  span {
    font-weight: 400;
    display: inline-block;
    margin-left: 5px;
  }

  img {
    vertical-align: middle;
    margin-right: 5px;
  }
}
</style>
